module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/sola-top-movie-61321964138a5bbac3e4189fc812293f.jpg";